import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCollaborationPointerRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCollaborationPointerRight"><Path d="M14.5498 22.1123L11.2178 12.7812L1.8877 9.4502L20.5479 3.45215L14.5498 22.1123Z" fill="currentColor"/><Path d="M8.81641 14.5518L9.29102 14.709L9.44824 15.1836L11.4482 21.1836L9.55176 21.8164L7.70898 16.29L2.18359 14.4482L2.81641 12.5518L8.81641 14.5518Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCollaborationPointerRight;
